import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";

const BroadCastInfo = () => {
  return (
    <VStack
      w="100%"
      pb=""
      pt=""
      borderRadius="26px"
      bg={"rgba(255, 255, 255, 1)"}
    >
      <Stack
        justifyContent={"flex-start"}
        alignItems={"center"}
        flexDir="row"
        w="100%"
        p={"15px 25px"}
        mt="40px"
        flexWrap="wrap"
        flexDirection={"column"}
      >
        <Box width="13px" h="25px" bg="#601FEB" borderRadius="7px" />
        <Text
          fontFamily="ProximaNova"
          fontSize="20px"
          fontWeight="800"
          color="rgba(41, 45, 50, 1)"
          fontF=""
        >
          OBS Connection Info
        </Text>
        <Box
          borderBottom="1px solid rgba(236, 236, 236, 1)"
          w="100%"
          py="10px"
        ></Box>

        <Stack w="100%">
          <Box w="100%" mx="auto" my="15px">
            <FormControl w="100%" position="relative" mb="15px">
              <FormLabel
                position="absolute"
                left="22px"
                top="5px"
                zIndex="22"
                color="#000000"
                fontSize="12px"
                fontFamily="ProximaNova"
              >
                Server
              </FormLabel>
              <Input
                placeholder="Server"
                border={"none"}
                background="#E6E6E6"
                padding="20px 25px"
                h="65px"
                borderRadius="13px"
                color=" #000000"
                fontSize="14px"
                fontFamily="ProximaNova"
                value="313.2.53.434/live"
                _placeholder={{
                  color: " #000000",
                  fontSize: "14px",
                  fontFamily: "ProximaNova",
                }}
                w="100%"
              />
            </FormControl>
            <FormControl w="100%" position="relative">
              <FormLabel
                position="absolute"
                left="22px"
                top="5px"
                zIndex="22"
                color="#000000"
                fontSize="12px"
                fontFamily="ProximaNova"
              >
                Stream Key
              </FormLabel>
              <Input
                placeholder="Stream Key"
                border={"none"}
                background="#E6E6E6"
                padding="20px 25px"
                h="65px"
                borderRadius="13px"
                color=" #000000"
                fontSize="14px"
                fontFamily="ProximaNova"
                value="test?key=supersecret"
                _placeholder={{
                  color: " #000000",
                  fontSize: "14px",
                  fontFamily: "ProximaNova",
                }}
                w="100%"
              />
            </FormControl>
            <Button color="#fff" 
            mt="20px"
            borderRadius="13px"
            fontSize="15px"
             fontWeight='600'
              fontFamily="ProximaNova" bg="#0071C1" w="100%"
            h="53px"
            _hover={{
                bg:"#0071C1"
              }}
            >
              Start Live Broadcast
            </Button>
          </Box>
        </Stack>
      </Stack>
    </VStack>
  );
};

export default BroadCastInfo;
